<template>
  <div>
    <BlocoFiltroPesquisa
      :nome-do-form="nomeDoForm"
      :ordenar-por="['nome']"
      :ordenar-nomes="['Nome']"
      @pesquisar="pesquisar"
      @ordenar="ordenar"
      @novo="novo"
    >
      <template #form>
        <div class="row">
          <div class="col-xs-12 col-sm-10 col-md-10 col-lg-10">
            <CampoNome :valor="filtro.nome" @atualizar="filtro.nome = $event" />
          </div>
          <div class="col-xs-12 col-sm-2 col-md-2 col-lg-2">
            <SelecionarSituacao
              id="ativo"
              :valor="filtro.ativo"
              @atualizar="filtro.ativo = $event"
            />
          </div>
        </div>
      </template>
    </BlocoFiltroPesquisa>
    <BlocoPaginadorPesquisa
      :total="total"
      :modo-resultado="modoResultado"
      @paginaAlterada="paginaAlterada"
      @modoAlterado="modoAlterado"
    />
    <BlocoResultadoPesquisa :total="total" :modo-resultado="modoResultado">
      <template #tabela><ConvenioTabela :convenios="convenios" /></template>
      <template #fichas>
        <div
          v-for="convenio in convenios"
          :key="convenio._id"
          class="col-xs-12 col-sm-6 col-md-4 col-lg-3"
        >
          <ConvenioFicha :convenio="convenio" />
        </div>
      </template>
    </BlocoResultadoPesquisa>
  </div>
</template>

<script>
import { ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'

import BlocoFiltroPesquisa from '@/componentes/formulario/BlocoFiltroPesquisa'
import BlocoPaginadorPesquisa from '@/componentes/formulario/BlocoPaginadorPesquisa'
import BlocoResultadoPesquisa from '@/componentes/formulario/BlocoResultadoPesquisa'
import CampoNome from '@/componentes/formulario/CampoNome'
import SelecionarSituacao from '@/componentes/formulario/SelecionarSituacao'
import { useMenu } from '@/composables/useMenu'
import { usePesquisa } from '@/composables/usePesquisa'
import ConvenioServico from '@/servicos/ConvenioServico'

import ConvenioFicha from './ConvenioFicha'
import ConvenioTabela from './ConvenioTabela'

export default {
  name: 'Convenios',
  components: {
    ConvenioFicha,
    ConvenioTabela,
    BlocoFiltroPesquisa,
    CampoNome,
    SelecionarSituacao,
    BlocoResultadoPesquisa,
    BlocoPaginadorPesquisa,
  },
  setup() {
    const router = useRouter()
    const route = useRoute()
    const convenios = ref([])
    const servico = new ConvenioServico()
    const nomeResultado = 'convenios'
    const nomeDoForm = 'ConveniosForm'
    const filtro = ref({
      nome: '',
      ativo: '',
    })
    const pesquisa = usePesquisa({
      filtro,
      resultado: convenios,
      servico,
      nomeResultado,
      nomeDoForm,
      cacheFormularioAtivo: true,
      onNovo: () => router.replace({ path: route.path + '/cadastro' }),
    })
    useMenu(13)
    return { convenios, filtro, ...pesquisa }
  },
}
</script>
